import './App.css';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import VisionSection from './components/VisionSection';
import CommunitySection from './components/CommunitySection';
import SupportSection from './components/SupportSection';
import Footer from './components/Footer';
import HexBackground from './components/HexBackground';

function App() {
  return (
    <div className="app">
      <HexBackground />
      <main className="main-content">
        <HeroSection />
        <MissionSection />
        <VisionSection />
        <CommunitySection />
        <SupportSection />
        <Footer />
      </main>
    </div>
  );
}

export default App;